$shm_projects_catalog $mol_book2
	projects_list_visible? true
	new_project_opened? false
	new_project_title? \
	filter? \
	add? null
	pages <= catalog_pages /
	Menu_page $mol_page
		title \Проекты
		head /
			<= List_head $shm_list_head
				title \Проекты
				filter? <=> filter? \
				add? <=> add? null
				Close null
				Settings null
		body /
			<= Projects $shm_tree
				roots <= project_roots /
				children* <= project_children* /
				expanded*? <=> project_expanded*? true
				Item* <= Project_link*
	New_project_page $mol_page
		title \Новый проект
		body /
			<= New_project_form $mol_view
				sub /
					<= New_project_title_field $mol_form_field
						name \Название проекта
						Content <= New_project_title $mol_string
							value? <=> new_project_title? \
					<= New_project_actions $mol_view
						sub /
							<= New_project_create $mol_button_major
								title \Создать
								enabled <= new_project_create_enabled true
								click? <=> new_project_create? null
							<= New_project_cancel $mol_button_minor
								title \Отмена
								click? <=> new_project_cancel? null
	Project_link* $mol_link
		arg <= project_arg* *
		current <= project_current* false
		title <= project_title* \
		sub /
			<= Project_title* $mol_view
				sub / <= project_title* \
			<= Project_type* $mol_speck
				value <= project_type* \
				style *
					^
					left \auto
					right \8px
					top \-4px
				attr *
					^
					aria-hidden \true
	Project* $shm_projects_page
		project_id <= project_id* \
